function relativeArea(relativeCoords) {
  const [x1, y1, x2, y2] = relativeCoords;
  const width = x2 - x1;
  const height = y2 - y1;
  const area = width * height;
  return area;
}

export default relativeArea;
